import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material';

interface ConfirmDeleteDecisionTreeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  treeName: string;
  deleting: boolean;
  deleteError: string | null;
}

const ConfirmDeleteDecisionTreeDialog: React.FC<ConfirmDeleteDecisionTreeDialogProps> = ({
  open,
  onClose,
  onConfirm,
  treeName,
  deleting,
  deleteError,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar Eliminación</DialogTitle>
      <DialogContent>
        {deleteError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {deleteError}
          </Alert>
        )}
        <Typography>
          ¿Está seguro que desea eliminar el árbol de decisiones <strong>"{treeName}"</strong>? Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={deleting}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={deleting}
          startIcon={deleting ? <CircularProgress size={20} /> : null}
        >
          {deleting ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDecisionTreeDialog;
